<template>
    <div class="animated fadeIn">
        <LoadingWidget
            v-if="initStatus != 1"
            :status="initStatus"
            @init="init"
        />
        <b-card v-else>
            <h5 id="marketplace-title" class="mb-0">
                <i class="fa fa-fw fa-info-circle mr-2" />Detail
            </h5>
            <hr />
            <b-row>
                <b-col id="marketplace-details" md="6">
                    No. Faktur Invoice:
                    <strong>{{ data.invoice_no_faktur }}</strong
                    ><br />
                    No. Ref: <strong>{{ data.no_ref || "-" }}</strong
                    ><br />
                    Marketplace:
                    <strong>{{ data.source || "-" }}</strong
                    ><br />
                    Divisi: <strong>{{ data.invoice_division }}</strong
                    ><br />
                    Total (Marketplace):
                    <strong>Rp. {{ $helper.formatThousand(data.total) }}</strong
                    ><br />
                    Total (Original):
                    <strong
                        >Rp.
                        {{ $helper.formatThousand(data.invoice_total) }}</strong
                    ><br />

                    <div v-if="data.completed_at && data.completed_by">
                        Diselesaikan oleh:
                        <strong>{{ data.completed_by }}</strong
                        ><br />
                        Diselesaikan pada:
                        <strong
                            >{{ $helper.parseDate(data.completed_at) }},
                            {{
                                $helper.parseHourMinute(data.completed_at)
                            }}</strong
                        ><br />
                    </div>
                </b-col>
                <b-col id="marketplace-actions" md="6" class="text-right">
                    <template v-if="data.invoice_status !== 0">
                        <b-button
                            v-if="isCompleted ? canUpdate : canFinalize"
                            id="finalize-marketplace-button"
                            :variant="isCompleted ? 'primary' : 'success'"
                            class=""
                            @click="$bvModal.show('m-finalize-marketplace')"
                        >
                            <i
                                :class="
                                    isCompleted
                                        ? 'fa fa-pencil mr-2'
                                        : 'fa fa-check mr-2'
                                "
                            />
                            {{ isCompleted ? "Ubah" : "Finalisasi" }}
                        </b-button>
                    </template>
                </b-col>
            </b-row>

            <b-row class="mt-3">
                <b-col md="4">
                    <b-form-group label="No. Faktur">
                        <b-form-input
                            id="filter-noFaktur"
                            placeholder="Cari No. Faktur"
                            v-model="filter.noFaktur"
                            maxlength="50"
                            @keydown.enter="getItems"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="2">
                    <b-form-group label="Aksi">
                        <b-button
                            id="btn-search"
                            class="d-flex align-items-center flex-nowrap"
                            variant="primary"
                            @click="getItems()"
                        >
                            <i class="fa fa-search mr-2" />Cari
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
            
            <b-table
                id="marketplace-items-table"
                bordered
                hover
                show-empty
                no-local-sorting
                :items="data.items"
                :fields="fields"
                :busy="isBusy"
                responsive
                class="my-3"
                @sort-changed="onSortChanged"
            >
                <template v-slot:empty>
                    Data tidak ditemukan.
                </template>

                <template v-slot:cell(item_no_faktur)="row">
                    {{ row.item.item_no_faktur }}
                    <br>
                    <b-badge v-if="row.item.is_returned" variant="danger" class="ml-1">
                        Retur
                    </b-badge>
                </template>
                <template v-slot:cell(item_name)="row">
                    {{ row.item.item_type }}
                    <div class="small text-muted">
                        {{ row.item.item_kind }} -
                        {{ row.item.item_brand }}
                    </div>
                </template>
                <template v-slot:cell(price)="row">
                    <strong>
                        Rp.
                        {{ $helper.formatThousand(row.item.total) }}
                    </strong>
                    <br />
                    <div class="small">
                        Original
                        <strong>
                            Rp.
                            {{
                                $helper.formatThousand(
                                    row.item.invoice_detail_total
                                )
                            }}
                        </strong>
                    </div>
                </template>
                <template v-slot:cell(discount)="row">
                    Rp. {{ $helper.formatThousand(row.item.discount) }}
                </template>
                <template v-slot:cell(fee)="row">
                    Rp. {{ $helper.formatThousand(row.item.fee_total) }}
                </template>
                <template v-slot:cell(subtotal)="row">
                    Rp. {{ $helper.formatThousand(row.item.subtotal) }}
                </template>
                <template v-slot:cell(selection)="row">
                    <b-button
                        v-if="!row.item.is_returned"
                        :variant="
                            row.item.selectedForReturn ? 'primary' : 'dark'
                        "
                        size="sm"
                        @click="toggleSelection(row.item)"
                    >
                        <i
                            :class="
                                row.item.selectedForReturn
                                    ? 'fa fa-check'
                                    : 'fa fa-minus'
                            "
                        />
                    </b-button>
                </template>
                <template v-slot:cell(action)="row">
                    <b-button
                        id="detail-item-button"
                        size="sm"
                        variant="primary"
                        v-b-tooltip.hover.top
                        title="Detail"
                        @click="prompDetailItem(row.item)"
                    >
                        <i class="fa fa-fw fa-info" />
                    </b-button>
                </template>
            </b-table>
            <div
                v-if="data.status !== 2 && data.invoice_status !== 0 && canReturn"
                class="mt-3 text-right"
            >
                <b-button
                    id="btn-return-items"
                    variant="danger"
                    @click="confirmReturnItems"
                >
                    Retur Barang Terpilih
                </b-button>
            </div>
        </b-card>

        <ModalFinalisasiMarketplace
            :data="data"
            :isCompleted="isCompleted"
            :optFees="optFees"
            :optMarketplaces="optMarketplaces"
            @submit="handleModalSubmit"
        />

        <ModalDetailItem :item="selectedItem" />

        <ModalReturMarketplace
            :data="data"
            :itemsToReturn="itemsToReturn"
            :optFees="optFees"
            @submit="handleReturSubmit"
        />
    </div>
</template>

<script>
import EnumPermissions from "@/shared/enum-permissions";
import ModalDetailItem from "./ModalDetailItem.vue";
import ModalFinalisasiMarketplace from "./ModalFinalisasiMarketplace.vue";
import ModalReturMarketplace from "./ModalReturMarketplace.vue";

export default {
    components: {
        ModalDetailItem,
        ModalFinalisasiMarketplace,
        ModalReturMarketplace
    },
    data() {
        return {
            isBusy: false,
            initStatus: 0,

            data: {
                items: []
            },

            selectedItem: {},
            itemsToReturn: [],

            sortBy: null,
            sortDesc: false,

            optFees: [],
            optMarketplaces: [],

            filter: {
                noFaktur: "",
            }
        };
    },

    methods: {
        init() {
            this.initStatus = 0;
            this.optFees = [];
            this.optMarketplaces = [];

            let getData = this.getItems();

            let getFees = this.$axios
                .get("master/marketplace-fees/options")
                .then(res => {
                    this.optFees = [];
                    res.data.data.map(item => {
                        this.optFees.push({
                            value: item.id,
                            text: item.name,
                            type: item.type
                        });
                    });
                })
                .catch(error => this.$helper.parseError(this, error));

            let getMarketplaces = this.$axios
                .get("master/marketplaces")
                .then(res => {
                    this.optMarketplaces = [];
                    res.data.data.map(item => {
                        this.optMarketplaces.push({
                            value: item.id,
                            text: item.name
                        });
                    });
                })
                .catch(error => this.$helper.parseError(this, error));

            Promise.all([getData, getFees, getMarketplaces])
                .then(() => {
                    this.initStatus = 1;
                })
                .catch(
                    error => (
                        this.$helper.parseError(this, error),
                        (this.initStatus = -1)
                    )
                );
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy;
            this.sortDesc = ctx.sortDesc;
            this.getItems();
        },

        prompDetailItem(item) {
            this.selectedItem = item;
            this.$bvModal.show("m-detail-item");
        },

        getItems() {
            this.isBusy = true;
            let param = "";

            if (!this.$helper.isBlank(this.sortBy)) {
                param += "sortBy=" + this.sortBy;
                param += "&sortDesc=" + this.sortDesc;
            }

            if (!this.$helper.isBlank(this.filter.noFaktur)) {
                param += "&no_faktur_pgi=" + this.filter.noFaktur;
            }

            return this.$axios
                .get("marketplace-sales/" + this.$route.params.id + "?" + param)
                .then(res => {
                    let data = res.data.data;
                    data.items = data.items.map(item => ({
                        ...item,
                        selectedForReturn: false
                    }));
                    this.data = data;
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => {
                    this.isBusy = false;
                });
        },

        toggleSelection(item) {
            item.selectedForReturn = !item.selectedForReturn;
        },

        confirmReturnItems() {
            this.itemsToReturn = this.data.items.filter(
                it => it.selectedForReturn
            );

            if (this.itemsToReturn.length == 0) {
                return this.$helper.toastError(
                    this,
                    "Mohon memilih minimal 1 barang untuk diretur!"
                );
            }

            this.$bvModal.show("m-retur");
        },

        handleReturSubmit(event) {
            const { payload, onSuccess, onError } = event;

            this.$axios
                .post("marketplace-returns", payload)
                .then(() => {
                    this.$helper.toastSuccess(
                        this,
                        "Retur marketplace berhasil!"
                    );
                    this.$bvModal.hide("m-retur");
                    this.init();
                    if (onSuccess) onSuccess();
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                    if (onError) onError();
                });
        },

        handleModalSubmit(event) {
            const { payload, isUpdate, onSuccess, onError } = event;

            const request = isUpdate
                ? this.$axios.put(
                      `marketplace-sales/${this.$route.params.id}`,
                      payload
                  )
                : this.$axios.post("marketplace-sales", payload);

            request
                .then(() => {
                    const successMessage = isUpdate
                        ? "Data penjualan marketplace berhasil diubah!"
                        : "Data penjualan marketplace berhasil disimpan!";

                    this.$helper.toastSuccess(this, successMessage);
                    this.$bvModal.hide("m-finalize-marketplace");

                    this.init();

                    if (onSuccess) onSuccess();
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                    if (onError) onError();
                });
        }
    },
    created() {
        this.init();
    },
    computed: {
        fields() {
            const base = [
                { key: "item_no_faktur", label: "No. Faktur Barang" },
                { key: "item_name", label: "Barang" },
                { key: "subtotal", label: "Subtotal" },
                { key: "discount", label: "Diskon Penjual" },
                { key: "fee", label: "Biaya Marketplace" },
                { key: "price", label: "Total" },
                { key: "action", label: "Aksi" }
            ];

            if (this.data.status !== 2 && this.canReturn) {
                base.unshift({ key: "selection", label: "" });
            }

            return base;
        },
        isCompleted() {
            return !!(this.data.completed_at && this.data.completed_by);
        },
        canFinalize() {
            return (
                this.$helper.checkRoleNumber(
                    EnumPermissions.FINALISASI_PENJUALAN_MARKETPLACE.toString(),
                    localStorage.getItem("permissions")
                ) || localStorage.getItem("roleName").includes("Superadmin")
            );
        },
        canUpdate() {
            return (
                this.$helper.checkRoleNumber(
                    EnumPermissions.EDIT_PENJUALAN_MARKETPLACE.toString(),
                    localStorage.getItem("permissions")
                ) || localStorage.getItem("roleName").includes("Superadmin")
            );
        },
        canReturn() {
            return (
                this.$helper.checkRoleNumber(
                    EnumPermissions.PENJUALAN_MARKETPLACE_RETUR.toString(),
                    localStorage.getItem("permissions")
                ) || localStorage.getItem("roleName").includes("Superadmin")
            );
        }
    }
};
</script>

<style></style>
